import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '/tree',
      name: 'tree',
      component: () => import('./app/board/temp/Tree.vue')
    },
    {
      path: '/test2',
      name: 'test2',
      component: () => import('./app/board/temp/Edit19.vue')
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('./app/board/temp/Edit13.vue')
    },
    {
      path: '/account/findid',
      name: 'findId',
      component: () => import('./app/account/find/FindId.vue')
    },
    {
      path: '/account/findpwd',
      name: 'findPwd',
      component: () => import('./app/account/find/FindPwd.vue')
    },
    {
      path: '/account/signup',
      name: 'signUp',
      component: () => import(`./app/account/signup/SignUp.vue`)
    },
    {
      path: '/account/withdrawal',
      name: 'withdrawal',
      component: () => import('./app/account/Withdrawal.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./app/account/Login.vue')
    },
    {
      path: '/',
      component: () => import('@/component/container/MainContainer'),
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import('./app/user/Home.vue')
        },
        {
          path: 'mypage',
          name: 'mypage',
          meta: {
            isLoggedIn: true
          },
          component: () => import('./app/user/mypage/MyPage.vue')
        },
        {
          path: 'boards/:boardId',
          name: 'boardList',
          component: () => import('./app/board/BoardList.vue'),
          props: true
        },
        {
          path: 'boards/:boardId/create',
          name: 'boardCreate',
          component: () => import('./app/board/BoardEdit.vue'),
          props: true
        },
        {
          path: 'boards/:boardId/seqs/:seq/edit',
          name: 'boardEdit',
          component: () => import('./app/board/BoardEdit.vue'),
          props: true
        },
        {
          path: 'boards/:boardId/seqs/:seq/answer',
          name: 'boardAnswer',
          component: () => import('./app/board/BoardEdit.vue'),
          props: true
        },
        {
          path: 'boards/:boardId/seqs/:seq',
          name: 'boardView',
          component: () => import('./app/board/BoardView.vue'),
          props: true
        },
        {
          path: 'boards/:boardId/seqs/:seq/design',
          name: 'designView',
          component: () => import('./app/board/DesignView.vue'),
          props: true
        },
        {
          path: 'boards/:boardId/seqs/:seq/component',
          name: 'componentView',
          component: () => import('./app/board/ComponentView.vue'),
          props (route) {
            const props = { ...route.params }
            props.seq = +props.seq
            return props
          }
          // props: true
        }
      ]
    },
    {
      path: '/admin',
      meta: {
        isAdmin: true
      },
      component: () => import('@/component/container/MainContainer'),
      children: [
        {
          path: 'main',
          name: 'adminMain',
          component: () => import('./app/user/Home.vue')
        },
        {
          path: 'my-company',
          name: 'adminMyCompany',
          component: () => import('./app/admin/company/MyCompany.vue')
        },
        {
          path: 'my-terms',
          name: 'adminMyTerms',
          component: () => import('./app/admin/company/MyTerms.vue')
        },
        {
          path: 'company',
          name: 'adminCompany',
          component: () => import('./app/admin/company/AdminCompany.vue')
        },
        {
          path: 'company/create',
          name: 'adminCompanyCreate',
          component: () => import('./app/admin/company/AdminCompanyEdit.vue')
        },
        {
          path: 'company/:companyId',
          name: 'adminCompanyEdit',
          component: () => import('./app/admin/company/AdminCompanyEdit.vue')
        },
        {
          path: 'board-metas',
          name: 'adminBoardMeta',
          component: () => import('./app/boardMeta/BoardMeta.vue')
        },
        {
          path: 'board-metas/create',
          name: 'adminBoardMetaCreate',
          component: () => import('./app/boardMeta/BoardMetaEdit.vue')
        },
        {
          path: 'board-metas/:boardId',
          name: 'adminBoardMetaEdit',
          component: () => import('./app/boardMeta/BoardMetaEdit.vue')
        },
        {
          path: 'member',
          name: 'adminMember',
          component: () => import('./app/admin/member/AdminMember.vue')
        },
        {
          path: 'member/create',
          name: 'adminMemberCreate',
          component: () => import('./app/admin/member/AdminMemberEdit.vue')
        },
        {
          path: 'member/:userId',
          name: 'adminMemberEdit',
          component: () => import('./app/admin/member/AdminMemberEdit.vue')
        },
        {
          path: 'banners/type/:bannerType',
          name: 'adminBanner',
          component: () => import('./app/admin/banner/AdminBanner.vue')
        },
        {
          path: 'banners/type/:bannerType/create',
          name: 'adminBannerCreate',
          component: () => import('./app/admin/banner/AdminBannerEdit.vue')
        },
        {
          path: 'banners/type/:bannerType/:seq',
          name: 'adminBannerEdit',
          component: () => import('./app/admin/banner/AdminBannerEdit.vue')
        },
        {
          path: 'boards/:boardId',
          name: 'adminBoardList',
          component: () => import('./app/board/BoardList.vue'),
          props: true
        },
        {
          path: 'boards/:boardId/create',
          name: 'adminBoardCreate',
          component: () => import('./app/board/BoardEdit.vue'),
          props: true
        },
        {
          path: 'boards/:boardId/seqs/:seq',
          name: 'adminBoardEdit',
          component: () => import('./app/board/BoardEdit.vue'),
          props: true
        },
        {
          path: 'boards/:boardId/seqs/:seq/answer',
          name: 'adminBoardAnswer',
          component: () => import('./app/board/BoardEdit.vue'),
          props: true
        },
        {
          path: 'boards/:boardId/seqs/:seq',
          name: 'adminBoardView',
          component: () => import('./app/board/BoardView.vue'),
          props: true
        },
        {
          path: 'boards/:boardId/seqs/:seq/design/edit',
          name: 'adminBoardDesignEdit',
          component: () => import('./app/board/DesignEdit.vue'),
          props: true
        },

        {
          path: 'resources',
          name: 'adminResource',
          meta: {
            isHeadMaster: true
          },
          component: () => import('./app/admin/resource/AdminResource.vue')
        },
        {
          path: 'menus/user',
          name: 'adminUserMenu',
          meta: {
            isHeadMaster: true
          },
          component: () => import('./app/admin/menu/AdminMenu.vue')
        },
        {
          path: 'menus/master',
          name: 'adminMasterMenu',
          meta: {
            isHeadMaster: true
          },
          component: () => import('./app/admin/menu/AdminMenu.vue')
        }
      ]
    },
    // {
    //   path: '/system',
    //   meta: {
    //     isSystem: true
    //   },
    //   component: () => import('@/component/container/MainContainer'),
    //   children: [
    //     {
    //       path: 'main',
    //       name: 'systemMain',
    //       component: () => import('./app/system/main/SystemMain.vue')
    //     },
    //     {
    //       path: 'company',
    //       name: 'systemCompany',
    //       component: () => import('./app/system/company/SystemCompany.vue')
    //     },
    //     {
    //       path: 'company/create',
    //       name: 'systemCompanyCreate',
    //       component: () => import('./app/system/company/SystemCompanyEdit.vue')
    //     },
    //     {
    //       path: 'company/:companyId',
    //       name: 'systemCompanyEdit',
    //       component: () => import('./app/system/company/SystemCompanyEdit.vue')
    //     },
    //     {
    //       path: 'boards/:boardId',
    //       name: 'systemBoardList',
    //       component: () => import('./app/board/Board.vue')
    //     },
    //     {
    //       path: 'boards/:boardId/create',
    //       name: 'systemBoardCreate',
    //       component: () => import('./app/board/Board.vue')
    //     },
    //     {
    //       path: 'boards/:boardId/seq/:seq',
    //       name: 'systemBoardEdit',
    //       component: () => import('./app/board/Board.vue')
    //     },
    //     {
    //       path: 'boards/:boardId/seqs/:seq',
    //       name: 'systemBoardView',
    //       component: () => import('./app/board/Board.vue')
    //     }
    //   ]
    // },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.isLoggedIn)) {
    const { user } = store.state
    if (user && user.userId) {
      next(true)
    } else {
      next({
        name: 'login'
      })
    }
  } else if (to.matched.some(record => record.meta.isAdmin)) {
    const { user } = store.state
    if (user && user.role !== '' && user.role !== 'user') {
      next(true)
    } else {
      next({
        name: 'login'
      })
    }
  } else {
    next()
  }
})

export default router

// {
//   path: '/about',
//     name: 'about',
//       component: () => import('./views/About.vue'),
//         children: [
//           {
//             path: 'sub',
//             name: 'sub',
//             component: () => import('./views/Popup.vue')
//           }
//         ]
// },
